var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 3C19.134 3 16 6.134 16 10C16 14.604 20.5511 16.7448 21.1211 17.2578C21.7031 17.7818 22.1839 18.832 22.3789 19.498C22.4729 19.821 22.738 19.9852 23 19.9922C23.263 19.9852 23.5271 19.821 23.6211 19.498C23.8151 18.833 24.2959 17.7818 24.8789 17.2578C25.4489 16.7448 30 14.604 30 10C30 6.134 26.866 3 23 3ZM23 8C24.105 8 25 8.895 25 10C25 11.105 24.105 12 23 12C21.895 12 21 11.105 21 10C21 8.895 21.895 8 23 8ZM9 12C5.134 12 2 15.134 2 19C2 23.604 6.55109 25.7448 7.12109 26.2578C7.70309 26.7818 8.18391 27.832 8.37891 28.498C8.47291 28.821 8.738 28.9852 9 28.9922C9.263 28.9852 9.52709 28.821 9.62109 28.498C9.81509 27.833 10.2959 26.7818 10.8789 26.2578C11.4489 25.7448 16 23.604 16 19C16 15.134 12.866 12 9 12ZM9 17C10.105 17 11 17.895 11 19C11 20.105 10.105 21 9 21C7.895 21 7 20.105 7 19C7 17.895 7.895 17 9 17Z",
    fill: "#365EDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoute);
export default __webpack_public_path__ + "static/media/route.a3d83556.svg";
export { ForwardRef as ReactComponent };